import { isMac } from '@/utils/browser'

export const getShortcutWithCmdOrCtrl = (letter) => {
  return isMac() ? `⌘${letter}` : `Ctrl+${letter}`
}
